import { render, staticRenderFns } from "./bill-of-materials-assembly.vue?vue&type=template&id=54180fc4"
import script from "./bill-of-materials-assembly.vue?vue&type=script&lang=js"
export * from "./bill-of-materials-assembly.vue?vue&type=script&lang=js"
import style0 from "./bill-of-materials-assembly.vue?vue&type=style&index=0&id=54180fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports